import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Error404 from "containers/errors/Error404";
import Home from "containers/pages/Home";
import CuentosDashboard from "containers/pages/CuentosDashboard";
import CuentoPage from "containers/pages/CuentoPage";

function AnimatedRoutes(){
    const location = useLocation();
    return(
        <AnimatePresence>
          <Routes location={location} key={location.pathname}>
            {/* Error display */}
            <Route path="*" element={<Error404 />} />
            {/* Home display */}
            <Route path="/" element={<Home />} />
            {/* Cuentos dashboard */}
            <Route path="/cuentosDashboard" element={<CuentosDashboard />} />
            <Route path="/cuentos/:id" element={<CuentoPage />} />
          </Routes>
        </AnimatePresence>
    );
}

export default AnimatedRoutes;